
import {Component, Prop, Vue} from 'vue-property-decorator';
import vModal from './vModal.vue';
import {mapState} from "vuex";
import {LocalizationState} from "@/store/modules/LocalizationModule";
import { dateTimeDisplayFormat } from '@/utils/Defaults';
import { ItemCompact } from '@/models/ItemCompact';

@Component({
  components: {
    vModal,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    })
  }
})
export default class vAuditLogModal extends Vue {
  localizationState: LocalizationState;

  @Prop() modalTitle: string;
  @Prop() recipe: ItemCompact;
  @Prop() showAuditLogModal : boolean;

  get translations() {
    return this.localizationState.translations;
  }

  getFormatedDateTime(date: Date) {
    return this.$moment(date).format(dateTimeDisplayFormat);
  }

  cancelAuditModal(){
    this.showAuditLogModal = false;
    this.$emit("cancelAuditModal");
  }

}
  